<template>
    <div class="box">
        <div class="box-head">
            <div class="head-logo" @click="backHome">
                <div class="logo-con">
                    <img src="../../assets/image/head-left.png" style="height:100%;" />
                </div>
                <p>项目现场管理系统V1.0</p>
            </div>
            <div class="head-menu">
                <div class="head-menu-item" v-for="item in items" :key="item.id"
                    :class="{ 'curFirstMenu': item.id == menu.firstMenu.id }" @click="firstMenuFun(item)">
                    <div class="item-box">
                        <img :src="item.icon" style="height:50.5%;" v-if="item.id != menu.firstMenu.id" />
                        <img :src="item.icon2" style="height:50.5%;" v-else />
                        <p style="width:100%;font-size:0.8vw;padding: 5%;">{{ item.name }}</p>
                    </div>
                </div>
            </div>
            <div class="head-Info">
                <div class="head-pro">
                    <el-popover placement="bottom" width="300" trigger="click" popper-class="popover-fat fat300">
                        <div class="popover-box">
                            <p class="popover-box-p">
                                <el-input placeholder="请输入项目名称" suffix-icon="el-icon-search" @input="proNameFun"
                                    style="max-width:100%;" v-model="project.name">
                                </el-input>
                            </p>
                            <p v-if="showProList.length == 0" class="popover-box-p nowrap addPad"
                                style="text-align: center;">暂无数据</p>
                            <p v-for="item in showProList" :key="item.id" class="popover-box-p nowrap addPad"
                                :title="item.groupName" :class="{ 'curPro': item.groupId == groupId }"
                                @click="selctPro(item)">
                                {{ item.groupName }}
                            </p>
                        </div>
                        <div slot="reference" style="width:100%;display:flex;">
                            <p class="nowrap pro-name" @click="showProject" :title="groupName">{{ groupName }}</p>
                            <i class="el-icon-caret-bottom" @click="showProject" style="color:#fff;font-size:1vw;"></i>
                        </div>
                    </el-popover>
                </div>
                <div class="head-user">
                    <el-popover placement="bottom" width="170" trigger="click" style="width:100%;"
                        popper-class="popover-info">
                        <div class="myPersonal">
                            <div v-for="(item, index) in arr" :key="index" @click="selected(item.act)">{{ item.name }}
                                <span v-if="item.act == 1" style="color: #0490F9;">{{ dealtCount.wfq }}</span>
                                <span v-if="item.act == 2" style="color: #f00;">{{ dealtCount.wcsDcl }}</span>
                                <span v-if="item.act == 3" style="color: rgb(53, 179, 120);">{{ dealtCount.ycl }}</span>
                                <span v-if="item.act == 6" style="color:#f4a74f;">{{ dealtCount.csDcl }}</span>
                            </div>
                        </div>
                        <div slot="reference" class="head-user-con" @click="visiblePro = false, visiblePort = false">
                            <div v-if="dealtCount.wcsDcl != 0" class="unmessage">{{ dealtCount.wcsDcl }}</div>
                            <i class="el-icon-user"
                                style="background:#fff;color:#0028E8;font-size: 2vw;border-radius: 50%;"></i>
                            <span :title="loginName" class="nowrap"
                                style="padding-left:5%;width: auto;flex: 1;text-align: left;">{{ loginName }}</span>
                        </div>
                    </el-popover>
                </div>
                <div style="position: relative;height:100%;display: flex;align-items: center;">
                    <el-popover placement="bottom" width="100" trigger="click" popper-class="popover-fat">
                        <div class="popover-box" style="width:5vw;">
                            <p v-for="item in portList" :key="item.id" :class="{ 'curPro': item.userType == port }"
                                @click="selectPort(item)" class="popover-box-p nowrap addPad">
                                {{ item.userTypeName }}
                            </p>
                        </div>
                        <div slot="reference" style="width:100%;display:flex;">
                            <i class="el-icon-caret-bottom" slot="reference"
                                style="color:#fff;font-size:1vw;cursor: pointer;"></i>
                        </div>
                    </el-popover>
                </div>
            </div>
        </div>
        <div class="box-main">
            <el-menu v-if="secondMenu.length" style="background: #E7F1FB;overflow: auto;" class="el-menu-vertical-demo"
                :default-active="menu.secMenu.id" :collapse="isCollapse" @select="selMenu">
                <el-menu-item index="-1">
                    <div style="width:100%;">
                        <i v-if="isCollapse" class="el-icon-menu"></i>
                        <i v-else class="el-icon-more"></i>
                    </div>
                </el-menu-item>
                <template v-for="item in secondMenu">
                    <el-submenu :key="item.id" v-if="item.isChild" :index="item.id">
                        <template slot="title">
                            <i v-if="item.icon == ''" class="el-icon-document"></i>
                            <img v-else :src="item.icon" class="el-icon-other"
                                style="max-width:30px;max-height:30px;margin-right: 10px;" />
                            <span>{{ item.name }}</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-for="child in item.children" :key="child.id" :index="child.id">
                                <div style="width:100%;text-align: left;" @click="pageMenu(child)">
                                    <i v-if="child.icon == ''" class="el-icon-document"></i>
                                    <img v-else-if="item.id != menu.secMenu.id || child.icon2 == ''" :src="child.icon"
                                        class="el-icon-other"
                                        style="max-width:30px;max-height:30px;margin-right: 10px;" />
                                    <img v-else :src="child.icon2" class="el-icon-other"
                                        style="max-width:30px;max-height:30px;margin-right: 10px;" />
                                    <span slot="title"> {{ child.name }}</span>
                                </div>
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-menu-item :key="item.id" v-else :index="item.id"
                        :class="{ 'sec-menu': item.id == menu.secMenu.id }">
                        <div style="width:100%;text-align: left;" @click="pageMenu(item)">
                            <i v-if="item.icon == ''" class="el-icon-document"></i>
                            <img v-else-if="item.id != menu.secMenu.id || item.icon2 == ''" :src="item.icon"
                                class="el-icon-other" style="max-width:30px;max-height:30px;margin-right: 10px;" />
                            <img v-else :src="item.icon2" class="el-icon-other"
                                style="max-width:30px;max-height:30px;margin-right: 10px;" />
                            <span slot="title"> {{ item.name }}</span>
                        </div>
                    </el-menu-item>
                </template>
            </el-menu>
            <div class="box-main-con" :class="{ 'toSmall': isCollapse, 'toAll': secondMenu.length == 0 }">
                <router-view></router-view>
            </div>
        </div>
        <el-dialog title="修改密码" :visible.sync="dialogVisible" center :append-to-body="true" :lock-scroll="false"
            class="add-form" width="30%">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px"
                class="demo-ruleForm">
                <el-form-item label="原密码" prop="oldPass">
                    <el-input type="password" v-model="ruleForm.oldPass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="pass">
                    <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPass">
                    <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="pswShow" width="30%">
            <div style="text-align:left;margin-bottom:6px">请输入解密密码！</div>
            <el-input placeholder="请输入密码" v-model="psw" show-password autocomplete="new-password"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="pswShow = false">取 消</el-button>
                <el-button type="primary" @click="decrypt">确 定</el-button>
            </span>
        </el-dialog>
        <!-- <div id="bdtts_div_id">
            <audio id="tts_autio_id" autoplay="autoplay" mute="true" preload>
                <source id="tts_source_id" :src="auditUrl" type="audio/mp3">
                <embed id="tts_embed_id" height="0" width="0">
            </audio>
        </div> -->
    </div>
</template>
<script>
import CryptoJS from 'crypto-js'
import util from '../../untils/util';
import myHttp from '../../untils/port';
import base from '../../untils/base';
import middle from '../../plugins/middleUtil'
export default {
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入新密码'))
            } else {
                if (this.ruleForm.checkPass !== '') {
                    this.$refs.ruleForm.validateField('checkPass')
                }
                callback()
            }
        }
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.ruleForm.pass) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        return {
            userBoss: '',
            isCollapse: false,
            isShow: false,
            visiblePro: false,//项目选择
            visiblePort: false,//端选择
            project: {
                name: '',
            },
            showProList: [],
            groups: [],
            portList: util.session.get('role') || [],
            groupId: '',
            groupName: '',
            port: '',//当前端
            items: [],//菜单
            menu: {
                firstMenu: {},//一级菜单
                secMenu: {},//二级菜单
            },
            secondMenu: [],//二级菜单
            arr: [
                { name: '我发起的', act: '1' },
                { name: '我未处理', act: '2' },
                { name: '我已处理', act: '3' },
                { name: '已超时', act: '6' },
                { name: '修改密码', act: '4' },
                // { name: '数据解密', act: '7' },
                { name: '退出', act: '5' }
            ],
            dealtCount: {
                dcl: 0,
                wfq: 0,
                ycl: 0,
            },
            hoverIndex: -1, // 菜单hover索引
            activeLinkId: 0, // 当前激活的菜单id
            loginName: '',
            defaultImg: require('../../assets/image/head-left.png'),
            header: {
                logoPhoto: '',
                platformName: '数字施工管理'
            },
            dialogVisible: false,
            ruleForm: {
                oldPass: '',
                pass: '',
                checkPass: ''
            },
            rules: {
                pass: [{ validator: validatePass, trigger: 'blur' }],
                checkPass: [{ validator: validatePass2, trigger: 'blur' }]
            },

            websocket: '',//..web推送
            timeOutObj: undefined,
            // auditUrl:''
            monitorId: '',
            psw: '',
            pswShow: false,
        };
    },
    mounted() {
        this.userBoss = util.session.get('userBoss') || ''
        if (util.session.get('roleId') && util.session.get('roleId') != '' && this.filter(util.session.get('roleId'), this.portList, 'userType')) {
            this.port = util.session.get('roleId')
        } else {
            this.port = this.portList.length > 0 ? this.portList[0].userType : ''
            util.session.set('roleId', this.port)
        }

        this.setGroupList()
        this.loginName = util.session.get('user') && util.session.get('user').name

        middle.$on('frameFun', (data) => {
            data.groupId = this.monitorId
            this.websocket.send(JSON.stringify(data))
        });
        middle.$on('isHome', (data) => {
            util.session.remove('curMenu')
            this.secondMenu = []
        });
    },
    methods: {
        aaa() {
            alert('123')
        },
        encrypt(word, keyStr) {
            keyStr = keyStr ? keyStr : ""; //判断是否存在key，不存在就用定义好的key
            var key = CryptoJS.enc.Utf8.parse(keyStr);
            var srcs = CryptoJS.enc.Utf8.parse(word);
            var encrypted = CryptoJS.AES.encrypt(srcs, key, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            });
            return encrypted.toString();
        },
        //二级菜单选择
        selMenu(index, path) {
            if (index == -1) {
                this.isCollapse = !this.isCollapse
            }
        },
        showProject() {
            this.visiblePro = !this.visiblePro
            this.project.name = ''
            this.showProList = this.groups
            this.visiblePort = false
        },
        //选择项目
        selctPro(obj) {
            this.groupId = obj.groupId
            this.groupName = obj.groupName
            this.visiblePro = false
            util.session.set('groupId', this.groupId)
            util.session.set('groupName', this.groupName)
            this.$store.commit('setGroupId')
            this.initWebsocket();//socket推送
            this.relocationFun() //重新定位
            this.getMenu()


            //  去测试项目的专属首页
            if (util.session.get('groupId') == '1174625235200061441') {
                this.$router.push({
                    path: '/newProjectHome'
                })
            } else {
                this.$router.push({
                    path: '/homeAll'
                })
            }

            // var that = this
            setTimeout(() => {
                this.$router.go(0)
            }, 200)
            // this.$router.go(0)
            this.project.name = ''
            this.showProList = this.groups
            this.getQsDealtCount()
        },
        relocationFun() {
            // console.log(123132)
            var m = util.session.get('curMenu') || {}
            if (m.secMenu && m.secMenu.id != '') {
                var path = this.$route.path
                if (path != m.secMenu.href) {
                    this.$router.replace(m.secMenu.href)
                }
            } else if (m.firstMenu && m.firstMenu.id != '') {
                var path = this.$route.path
                if (path != m.firstMenu.href) {
                    this.$router.replace(m.firstMenu.href)
                }
            }
        },
        //选择端
        selectPort(obj) {
            // if(this.port != obj.userType){
            //     this.port = obj.userType
            //     this.visiblePort = false
            //     util.session.set('roleId', this.port)
            //     this.$store.commit('getRoleId')
            //     util.session.remove('curMenu')
            //     this.setGroupList(1)
            // }
            if (this.port == obj.userType) return;
            util.session.set('roleId', obj.userType)
            util.session.remove('curMenu')
            util.session.remove('groupId')
            this.$store.commit("setGroupId")
            this.$store.commit("getRoleId")
            if (obj.userType == '5') {
                this.$router.push({ name: 'comHome' })
            } else if (obj.userType == '3') {
                this.$router.push({ name: 'buildHome' })
            }
        },
        //获取项目
        setGroupList(flag) {
            if (this.port == 1) {
                this.groupId = ''
                this.getMenu()
                if (flag == 1) {
                    this.$router.push({ name: 'userMan' })
                }
                return
            }
            var oldGroupId = util.session.get('groupId')  //用于判断海恒是否返回首页
            var userId = (this.$store.state.user && this.$store.state.user.id) || ''
            var userType = this.port
            var that = this
            myHttp.getGroupListByUserId({
                userId: userId,
                userType: userType
            }).then(function (resp) {
                if (resp.data.code == '200') {
                    var data = resp.data.data
                    if (that.port == '3') {
                        //企业端 - 数据
                        that.groups = data.entList || []
                    } else if (that.port == '4') {
                        //项目端 - 数据
                        var list = data.projectList || []
                        var list1 = []
                        for (var i = 0; i < list.length; i++) {
                            // if(list[i].groupId=='1289074551342186497' || list[i].groupId=='1291170532875464706'|| list[i].groupId=='1285159083388628994'||list[i].groupId=='1310827479341912066'){

                            // }else{
                            list1.push(list[i])
                            // }
                        }
                        that.groups = list1 || []
                    } else if (that.port == '2') {
                        //监管端
                        that.groups = data.supList || []
                    } else if (that.port == '5') {
                        //施工端 - 数据
                        that.groups = data.constructList || []
                    }
                    // that.groups = data.groupList||[]  1289074551342186497
                    that.showProList = that.groups
                    that.$store.commit('setProject', that.groups)
                    //获取当前企业或者项目id
                    if (undefined == that.$store.state.groupId || that.$store.state.groupId == '') {
                        that.groupId = that.groups.length > 0 ? that.groups[0].groupId : ''
                        that.groupName = that.groups.length > 0 ? that.groups[0].groupName : ''
                    } else {
                        that.groupId = that.idFilter(that.$store.state.groupId, that.groups)
                        that.groupName = util.common.getNameByList(util.session.get('groupId'), that.groups, 'groupId', 'groupName')
                    }
                    that.initWebsocket();//socket推送
                    var info = that.infoFilter(that.$store.state.groupId, that.groups)
                    // console.log(info)
                    that.header.logoPhoto =
                        info.logoPhoto && info.logoPhoto != ''
                            ? base.httpCtx + info.logoPhoto
                            : that.defuleImg
                    that.header.platformName =
                        info.platformName && '' != info.platformName
                            ? info.platformName
                            : '数字施工管理'
                    util.session.set('groupId', that.groupId)
                    util.session.set('groupName', that.groupName)
                    that.$store.commit('setGroupId')
                    that.getMenu()
                    that.getQsDealtCount()
                    if (that.port == '5' && flag == 1) {
                        //施工方企业端 - 跳转
                        setTimeout(function () {
                            that.$router.push({ name: 'comHome' })
                        }, 100)
                    } else if (that.port == '3') {
                        //建设方企业端
                        setTimeout(function () {
                            if (that.groupId == '1214807566895210497' && flag == 1) {
                                that.$router.push({ name: 'homeHai' })
                            } else if (flag == 1) {
                                that.$router.push({ name: 'stateData' })
                            }
                        }, 100)
                    } else if (that.port == '4' && flag == 1) {
                        //项目端 - 跳转
                        setTimeout(function () {
                            that.$router.push({ name: 'homeAll' })
                        }, 100)
                    }
                } else {
                    that.$message.error(resp.data.msg)
                }
            }, function () { }
            )
        },
        //根据id获取数据
        infoFilter(id, list) {
            var result = list && list.length > 0 ? list[0] : { id: '', logoPhoto: this.defuleImg, platformName: '数字施工管理' }
            for (var i = 0; i < list.length; i++) {
                if (id == list[i].groupId) {
                    result = list[i]
                }
            }
            return result
        },
        //判断是否属于user
        filter(id, list, str) {
            var result = false
            if (list.length > 0) {
                for (var i = 0; i < list.length; i++) {
                    if (list[i][str] == id) {
                        result = true
                    }
                }
            }
            return result
        },
        //当前id是否是项目List里
        idFilter(id, list) {
            var result = list && list.length > 0 ? list[0].groupId : ''
            for (var i = 0; i < list.length; i++) {
                if (id == list[i].groupId) {
                    result = id
                }
            }
            return result
        },
        //获取菜单 
        getMenu() {
            var userId = (this.$store.state.user && this.$store.state.user.id) || ''
            var userType = this.port
            var groupId = this.groupId
            var that = this
            myHttp.getMenuList({
                userId: userId,
                userType: userType,
                groupId: groupId
            }).then(function (resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.menuList
                    var filter = []
                    var btnMneu = []
                    for (var i = 0; i < list.length; i++) {
                        if (list[i].type == '2') {
                            list[i].href = '' == list[i].href ? '#' : list[i].href
                            list[i].icon = '' == list[i].icon || undefined == list[i].icon ? '' : base.httpCtx + list[i].icon
                            list[i].icon2 = '' == list[i].icon2 || undefined == list[i].icon2 ? '' : base.httpCtx + list[i].icon2
                            filter.push(list[i])
                        } else if (list[i].type == '3') {
                            btnMneu.push(list[i])
                        }
                    }
                    that.$store.commit('setBtnMenu', btnMneu)
                    list = util.common.listToTree('id', 'parentId', filter)
                    that.items = list
                    //判断当前是否有该菜单
                    var m = util.session.get('curMenu') || {}
                    if (m.secMenu && m.secMenu.id != '') {
                        if (!that.isExitMenu(m.secMenu.id, filter)) {
                            util.session.remove('curMenu')
                            if (list[0].children > 0) {
                                that.$router.replace(list[0].children[0].href)
                            } else {
                                that.$router.replace(list[0].href)
                            }
                        }
                    } else if (m.firstMenu && m.firstMenu.id != '') {
                        if (!that.isExitMenu(m.firstMenu.id, filter)) {
                            util.session.remove('curMenu')
                            if (list[0].children > 0) {
                                that.$router.replace(list[0].children[0].href)
                            } else {
                                that.$router.replace(list[0].href)
                            }
                        }
                    }

                    // if(!that.isExitMenu(m,filter)){
                    //     util.session.remove('curMenu')
                    //     if(list[0].children>0){
                    //         that.$router.replace(list[0].children[0].href)
                    //     }else{
                    //         that.$router.replace(list[0].href)
                    //     }
                    // }
                    that.setSeconMenuFun()
                } else {
                    that.$message.error(resp.data.msg)
                }
            }, function () { })
        },
        //判断是否有该菜单
        isExitMenu(id, list) {
            var result = false
            for (var i = 0; i < list.length; i++) {
                if (list[i].id == id) {
                    result = true
                }
            }
            return result
        },
        //设置二级菜单（初始化）
        setSeconMenuFun() {
            this.menu = util.session.get('curMenu')
            if (!this.menu) {
                this.menu = { firstMenu: { id: this.items[0].id, href: this.items[0].href } }
                if (this.items[0].children > 0) {
                    this.secondMenu = this.items[0].children
                    this.menu.secMenu = { id: this.items[0].children[0].id }
                }
            } else if (this.menu.secMenu && this.menu.secMenu.id != '') {
                this.secondMenu = util.common.getNameByList(this.menu.firstMenu.id, this.items, 'id', 'children') || []
            }
            this.isShow = true
        },
        //项目过滤
        proNameFun(val) {
            if (val == '') {
                this.showProList = this.groups
            } else {
                this.showProList = []
                var list = []
                for (var i = 0; i < this.groups.length; i++) {
                    if (this.groups[i].groupName.indexOf(val) > -1) {
                        this.showProList.push(this.groups[i])
                    }
                }
            }
        },
        //一级菜单点击方法
        firstMenuFun(obj) {
            // console.log(obj)
            this.menu.firstMenu = { id: obj.id, href: obj.href }
            if (obj.children && obj.children.length > 0) {
                this.secondMenu = obj.children
                if (obj.href && obj.href != '' && obj.href != '#') {
                    this.$router.push({ path: obj.href })
                } else {
                    this.menu.secMenu = obj.children[0]
                    if (obj.children[0].target == '_blank') {
                        let routeUrl = this.$router.resolve({
                            path: obj.children[0].href
                        });
                        window.open(routeUrl.href, '_blank');
                    } else {
                        this.$router.push({ path: obj.children[0].href })
                    }
                }
            } else {
                this.secondMenu = []
                if (obj.href == '/attendShoot') {
                    obj.href == '/attendShoot/' + this.groupId
                } else if (obj.href == '/attendShoot1') {
                    obj.href == '/attendShoot1/' + this.groupId
                }
                if (obj.target == '_blank') {
                    let routeUrl = this.$router.resolve({
                        path: obj.href
                    });
                    window.open(routeUrl.href, '_blank');
                } else {
                    this.$router.push({ path: obj.href })
                }
                this.menu.secMenu = undefined
            }
            util.session.set('curMenu', this.menu)
            this.isShow = true
        },
        //二级菜单点击方法
        pageMenu(obj) {
            if (obj.href == '/attendShoot') {
                var projectId = this.groupId;
                let routeUrl = this.$router.resolve({
                    name: "attendShoot",
                    params: { 'id': projectId }
                });
                window.open(routeUrl.href, '_blank');
            } else {
                this.menu.secMenu = { id: obj.id, href: obj.href }
                util.session.set('curMenu', this.menu)
                this.$router.push({ path: obj.href })
            }
        },
        decrypt() {
            myHttp.openDataSensitivePermissions({
                password: this.encrypt(this.psw, 'tongshengkeji123')
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.msg)
                    this.$router.go(0)
                } else {
                    this.$message.error(res.data.msg)
                }
            })
            // this.pswShow=false
        },
        //点击我的
        selected(stu) {
            if (stu == 7) {
                this.psw = ''
                this.pswShow = true

            }
            if (stu == 0) {
                if (!this.personId || this.personId == 'undefined' || '' == this.personId) {
                    this.$message.error('当前账号未在项目采集实名')
                    return
                }
                this.$router.push({ name: 'perFile', params: { id: this.personId } })
                this.dialogVisible = false
            }
            if (stu == 4) {
                this.dialogVisible = true
            } else if (stu == 5) {
                var type = util.session.get('type')
                util.session.clear()
                this.$store.commit('getToken')
                this.$store.commit('setUser')
                this.$store.commit('setGroupId')
                this.$store.commit('getRoleId')
                this.$store.commit('getRole')

                var that = this
                setTimeout(function () {
                    //     if (type == '1') {
                    //     that.$router.push({ name: 'loginHgd' })
                    //     } else if (type == '2') {
                    //     that.$router.push({ name: 'loginHh' })
                    //     } else if (type == '3') {
                    //     that.$router.push({ name: 'loginBh' })
                    //     } else if (type == '4') {
                    //     that.$router.push({ name: 'loginJk' })
                    //     } else {
                    //     that.$router.push({ name: 'loginTs' })
                    //     }
                    console.log(type)
                    if (type == '1') {
                        that.$router.push({ name: 'loginHgd' })
                    } else if (type == '6') {
                        that.$router.push({ name: 'loginGZ' })
                    } else if (type == '7') {
                        that.$router.push({ name: 'loginGx' })
                    } else if (type == '-1') {
                        window.location.href = 'http://47.103.123.116:18005/loginTs'
                    } else {
                        that.$router.push({ name: 'loginTs' })
                    }
                }, 100)
            } else if (stu == 1 || stu == 3) {
                this.$router.push({ name: 'mydealList', params: { type: stu } })
            } else if (stu == 6) {  //已超时
                this.$router.push({ name: 'mydealList', params: { type: 5 } })

            } else if (stu == 2) {  //我未处理
                this.$router.push({ name: 'mydealList', params: { type: 4 } })

            }
        },
        //提交修改密码
        submitForm(formName) {
            var that = this
            var userId = util.session.get('user').id || ''
            this.$refs[formName].validate(valid => {
                if (valid) {
                    myHttp.getUpdatePassWord({
                        id: userId,
                        oldPassWord: this.ruleForm.oldPass,
                        newPassword: this.ruleForm.pass
                    }).then(function (resp) {
                        if (resp.data.code == '200') {
                            that.$message.success('修改密码成功')
                            that.dialogVisible = false
                        } else {
                            that.$message.error(resp.data.msg)
                        }
                    }, function () { })
                } else {
                    return false
                }
            })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
        },
        //返回首页
        backHome() {
            // alert('123')
            // this.$router.push({path:'/homeAll'})
        },
        /***
         * 获取未处理数量
        */
        getQsDealtCount() {
            let that = this
            myHttp.getQsDealtCount({
                projectId: util.session.get('groupId'),
                userId: util.session.get('user').id
            })
                .then(function (resp) {
                    if (resp.data.code == '200') {
                        var data = resp.data.data.dealtCount || []
                        that.dealtCount = data
                    }

                })
        },

        //确定菜单焦点


        /**
        * 全局socket推送
        */
        initWebsocket() {
            var that = this;
            //判断当前浏览器是否支持WebSocket
            if (this.websocket && this.websocket != '') {
                this.websocket.close();
            }
            if ('WebSocket' in window) {
                var url = ''
                if (document.location.protocol == "https:") {
                    url = base.httpsWs + "/webSocketVoice/" + this.groupId + '/' + util.session.get('user').id;
                } else {
                    url = base.httpWs + "/webSocketVoice/" + this.groupId + '/' + util.session.get('user').id;
                }
                // var url = base.httpWs+"/webSocketVoice/"+this.groupId+'/'+util.session.get('user').id;
                // var url="ws://192.168.0.121:17001/webSocketVoice/"+this.groupId+'/'+util.session.get('user').id;
                // console.log(url)
                that.websocket = new WebSocket(url);
            }
            else {
                console.log('Not support websocket')
            }
            //连接发生错误的回调方法
            this.websocket.onerror = function () {

            };
            //连接成功建立的回调方法
            this.websocket.onopen = function (event) {
                // that.errorFlag = false
                // that.timeOutObj=null;
            }
            //接收到消息的回调方法
            this.websocket.onmessage = function (event) {
                if (event.data == "连接成功") return;
                var x = JSON.parse(event.data);
                console.log('==========frame====websocket=================')
                console.log(x)
                if (x.type == '1') {  //路由菜单
                    var name = x.result && x.result.name
                    that.toMenuPath(name, x.result)
                } else if (x.type == '2') { //人员信息
                    that.$router.push({ path: '/perFile/' + x.result.personId })
                } else if (x.type == '3') { //打开监控
                    that.monitorId = x.result.id
                    that.$router.push({ path: '/monitCtl/' + x.result.serial + '/' + x.result.channelNo + '/' + x.result.type + '/' + that.monitorId })
                } else if (x.type == '4') {//打开考勤信息
                    that.$router.push({ path: '/workerInfo/' + x.result.personId })
                } else if (x.type == '999') {
                    that.playVoice(x.result)
                }

            }
            //连接关闭的回调方法
            this.websocket.onclose = function () {
                this.timeOutObj = setTimeout(function () {
                    that.initWebsocket();
                }, 60000);
            }
            //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
            window.onbeforeunload = function () {
                that.websocket.close();
            }
        },
        //关闭连接
        closeWebSocket() {
            that.websocket.close();
        },
        //特殊字符
        nameFilter(name1, name2) {
            var result = false
            if (name2.indexOf('监控列表') > -1 && (name1.indexOf('监控') > -1 || name1.indexOf('摄像头') > -1)) {
                result = true
            }
            return result
        },
        //获取相应的页面
        toMenuPath(name, strData) {
            var zindex = 1
            var obj = {}
            for (var i = 0; i < this.items.length; i++) {
                // if(name.indexOf(this.items[i].name)>-1 ){  //|| this.nameFilter(name,this.items[i].name)
                if (name == this.items[i].name) {
                    zindex = 1
                    obj = this.items[i]
                    this.showPage(obj, zindex)
                    continue
                } else if (this.items[i].children && this.items[i].children.length > 0) {
                    var list = this.items[i].children
                    for (var j = 0; j < list.length; j++) {
                        //if(name.indexOf(list[j].name)>-1 ){ //|| this.nameFilter(name,list[j].name)
                        if (name == list[j].name) {
                            zindex = 2
                            obj = list[j]
                            this.secondMenu = this.items[i].children
                            this.menu.firstMenu = { id: this.items[i].id, href: this.items[i].href }
                            this.showPage(obj, zindex)
                            continue
                        } else if (list[j].children && list[j].children.length > 0) {
                            var list1 = list[j].children
                            for (var k = 0; k < list1.length; k++) {
                                if (name == list1[k].name) {
                                    zindex = 3
                                    obj = list1[k]
                                    this.secondMenu = this.items[i].children
                                    this.menu.firstMenu = { id: this.items[i].id, href: this.items[i].href }
                                    this.showPage(obj, zindex)
                                }
                            }
                        }
                    }
                    continue
                }
            }
            if (obj && obj.name) {
                this.playVoice(obj.name + '打开成功')
            } else {
                this.playVoice('没有找到页面！')
            }
        },
        //打开页面
        showPage(obj, index) {
            if (index == 1) {
                this.menu.firstMenu = { id: obj.id }
                if (obj.children && obj.children.length > 0) {
                    this.secondMenu = obj.children
                    this.showPage(obj.children[0], 2)
                } else {
                    this.secondMenu = []
                    this.$router.push({ path: obj.href })
                }
            } else if (index == 2) {
                this.menu.secMenu = { id: obj.id }
                if (obj.children && obj.children.length > 0) {
                    this.$router.push({ path: obj.children[0].href })
                } else {
                    this.$router.push({ path: obj.href })
                }
            } else if (index == 3) {
                this.menu.secMenu = { id: obj.id }
                this.$router.push({ path: obj.href })
            }
        },
        // 语音播报的函数
        // handleSpeak(text) {
        //   msg.text = text;     // 文字内容: 小朋友，你是否有很多问号
        //   msg.lang = "zh-CN";  // 使用的语言:中文
        //   msg.volume = 1;      // 声音音量：1
        //   msg.rate = 1;        // 语速：1
        //   msg.pitch = 10;       // 音高：1
        //   synth.speak(msg);    // 播放
        // },
        // 语音停止
        // handleStop(e) {
        //   msg.text = e;
        //   msg.lang = "zh-CN";
        //   synth.cancel(msg);
        // },
        playVoice(text) {
            // console.log('=====小朋友，内容====='+text)
            var ttsText = text;
            new Audio(
                'http://tts.baidu.com/text2audio?cuid=baiduid&ctp=1&vol=15&lan=zh&per=1&pit=9&spd=8&tex=' + ttsText + '&tok=' + base.videoToken
            ).play();
        },

    },
    destroyed() {
        if (this.websocket) {
            this.websocket.close();
        }
    },
}
</script>

<style>
@import '../../assets/css/common.css';

.el-menu-item-group__title {
    display: none;
}

.el-menu {
    background: transparent;
}

.popover-fat {
    padding: 0;
    min-width: fit-content;
}

.popover-fat .el-input__inner {
    border-top: 0;
    border-radius: 0;
    border-left: 0;
    border-right: 0;
    height: 5vh;
}

.el-submenu__title span {
    font-size: 0.8vw;
}
</style>

<style scoped>
.box {
    width: 100%;
    height: 100vh;
    position: relative;
}

.box-head {
    width: 100%;
    height: 9.3vh;
    position: relative;
    background: #409EFF;
    display: flex;
}

.head-logo {
    width: 10%;
    height: 100%;
    position: relative;
    background: #0020E6;
    display: flex;
    justify-content: center;
    justify-items: center;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
}

.logo-con {
    width: 30%;
    height: 58%;
    position: relative;
    padding: 0.4vh;
    background: #fff;
    border-radius: 5px;
}

.head-logo p {
    width: 100%;
    position: relative;
    height: auto;
    font-size: 1.6vh;
    color: #fff;
    text-align: center;
}

.head-menu {
    width: 70%;
    height: 100%;
    position: relative;
    display: flex;
    background: linear-gradient(to right, #0490F9, #0028E8);
}

.head-menu-item {
    width: 8%;
    height: 100%;
    position: relative;
    padding: 0.5% 1%;
}

.item-box {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    justify-items: center;
    border-radius: 4px;
    align-content: center;
    align-items: center;
    cursor: pointer;
    color: #fff;
}

.head-Info {
    width: 20%;
    height: 100%;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    background: #0028E8;
    padding-right: 2vw;
}

.head-pro {
    width: 60%;
    height: 100%;
    position: relative;
    font-size: 0.8vw;
    color: #fff;
    display: flex;
    align-content: center;
    align-items: center;
    padding-right: 3%;
    cursor: pointer;
}

.head-pro>span {
    width: 100%;
}

.head-pro .pro-name {
    width: 90%;
    text-align: right;
}

.head-user {
    width: 40%;
    height: 100%;
    position: relative;
    font-size: 0.8vw;
    color: #fff;
    display: flex;
    align-content: center;
    align-items: center;
    padding: 4%;
}

.head-user-con {
    width: 100%;
    display: flex;
    align-content: center;
    align-items: center;
    cursor: pointer;
    position: relative;
}

.box-main {
    width: 100%;
    height: 90.7vh;
    position: relative;
    display: flex;
}

.box-main-con {
    width: 89.6vw;
    height: 100%;
    position: relative;
    background: #ecf0f5;
}

.toSmall {
    width: 96.27vw;
}

.toAll {
    width: 99.6vw;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 10vw;
    min-height: 400px;
}

.el-menu-item {
    display: flex;
    align-items: center;
    align-content: center;
}

.el-menu--collapse {
    width: 3.33vw;
}

.popover-box {
    width: 16vw;
    height: auto;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    max-height: 50vh;
    overflow: auto;
}

.popover-box-p {
    height: 5vh;
    line-height: 4vh;
    cursor: pointer;
    text-align: center;
    width: 16vw;
}

.popover-box-p:hover {
    color: blue;
    background: rgba(64, 158, 255, 0.5);
}

.addPad {
    padding: 2%;
}

.curPro {
    color: blue;
}

.curFirstMenu .item-box {
    background: #fff;
    color: #0028E8;
}

.curFirstMenu p {
    color: #0028E8;
}

.sec-menu,
.el-menu-item:hover {
    background: #fff;
    border-left: 3px solid #47C3FF;
}

.popover-info {
    padding: 5%;
}

.myPersonal {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.myPersonal>div {
    padding: 5%;
    cursor: pointer;
}

.myPersonal>div:hover {
    color: #0028E8
}

.el-menu-item-group .is-active {
    background: #fff;
    border-left: 3px solid #47C3FF;
}

.unmessage {
    position: absolute;
    background: #f00;
    color: #fff;
    border-radius: 50%;
    z-index: 1000;
    padding: 4px;
    left: 28px;
    top: -15px;
    font-size: 10px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-around;
}
</style>
